import { Component, Element, Event, EventEmitter, h, Prop } from '@stencil/core';

@Component({
	shadow: true,
	styleUrl: 'zds-breadcrumb.scss',
	tag: 'zds-breadcrumb',
})
export class ZdsBreadcrumb {
	@Element() hostElement: HTMLElement;
	@Event() zdsClick: EventEmitter<MouseEvent>; // Internal; passed from zds-link

	@Prop() link: string;
	@Prop() clickable: boolean;

	render() {
		if (!this.link && !this.clickable) {
			return (
				<span class="zds-breadcrumb__text">
					<slot />
				</span>
			);
		}

		return (
			<zds-link link={this.link}>
				<div class="zds-breadcrumb__text">
					<slot />
				</div>
			</zds-link>
		);
	}
}
